import React from 'react';
import { Field } from 'formik';
import CustomInputTextComponent from 'components/Form/CustomInputTextComponent';
import InputPhone from 'components/Form/InputPhone';
import {Checkbox} from "components/Form/SpecialButtons";

const GeneralForm = ({ element }) => (
	<div>
		<Field
			component={Checkbox}
			name='disabled'
			customlabel='Désactivée'
			disabled
		/>
		<Field
			type='text'
			name='sil_id'
			customlabel='ID Geslab'
			component={CustomInputTextComponent}
			disabled
		/>
		<Field
			type='text'
			name='name'
			customlabel='Nom'
			component={CustomInputTextComponent}
			required
			disabled
		/>
		<Field
			type='text'
			name='type'
			customlabel='Type'
			component={CustomInputTextComponent}
			disabled
		/>
		<Field
			type='text'
			name='department'
			customlabel='Service'
			component={CustomInputTextComponent}
			disabled
		/>
		<Field
			type='text'
			name='address'
			customlabel='Adresse'
			component={CustomInputTextComponent}
			disabled
		/>
		<Field
			type='text'
			name='postal_code'
			customlabel='Code postal'
			component={CustomInputTextComponent}
			disabled
		/>
		<Field
			type='text'
			name='city'
			customlabel='Ville'
			component={CustomInputTextComponent}
			disabled
		/>
		<Field
			component={InputPhone}
			name='phone1'
			customlabel='Téléphone 1'
			disabled
		/>
		<Field
			component={InputPhone}
			name='phone2'
			customlabel='Téléphone 2'
			disabled
		/>
		<Field
			component={InputPhone}
			name='phone3'
			customlabel='Téléphone 3'
			disabled
		/>
        
		<Field
			component={InputPhone}
			name='fax1'
			customlabel='Fax 1'
			disabled
		/>
		<Field
			component={InputPhone}
			name='fax2'
			customlabel='Fax 2'
			disabled
		/>
		<Field
			component={InputPhone}
			name='fax3'
			customlabel='Fax 3'
			disabled
		/>

	</div>
);

export default GeneralForm;
